import { EMPTY_STRING, SUSPICIOUS_NAME_TOKENS } from "src/components/constant/constant";

export const formatCurrency = (amount: number, currency: string = "AUD"): string => {
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2
  }).format(amount);
};

export function convertToCSV<T extends Record<string, any>>(data: T[]): string {
  if (!data || !data.length) return EMPTY_STRING;
  const keys = Object.keys(data[0]);
  const escape = (value: any) => {
    if (value == null) return EMPTY_STRING;
    let str = String(value);

    if (str.includes('"')) str = str.replace(/"/g, '""');
    if (str.search(/[",\n]/g) >= 0) str = `"${str}"`;
    return str;
  };
  const header = keys.join(",");
  const rows = data.map((row) => keys.map((k) => escape(row[k])).join(","));

  return [header, ...rows].join("\n");
}

export const formatToRunningCase = (input: string | null | undefined): string => {
  if (!input) {
    return EMPTY_STRING;
  }

  return input
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatInitial = (initial: string | undefined | null): string => {
  if (!initial) return "Mr.";
  return initial.endsWith(".") ? initial : `${initial}.`;
};

const isSuspiciousNameToken = (token: string): boolean => {
  const lower = token.toLowerCase();

  return SUSPICIOUS_NAME_TOKENS.some((suspicious) => suspicious === lower);
};

export const formatFullName = (first?: string | null, last?: string | null): string => {
  const parts = [first, last]
    .map((part) => (part ?? EMPTY_STRING).trim())
    .flatMap((part) => part.split(/\s+/))
    .filter((part) => part.length > 0 && !isSuspiciousNameToken(part));

  return parts.join(" ");
};

export const getOrdinalSuffix = (number: number) => {
  const suffixes = ["th", "st", "nd", "rd"];
  const value = number % 100;

  return suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0];
};

export const getDecimalNumber = (amount: number) => {
  return Math.abs(parseFloat(amount?.toFixed(3)));
};

// Money for DISPLAY — always two decimals (2.3 -> "2.30", 2 -> "2.00").
// getDecimalNumber returns a number for arithmetic and drops trailing zeros, so
// use this at display sites instead.
export const formatMoney = (amount?: number) => Math.abs(amount ?? 0).toFixed(2);

export const formatSignedDollar = (amount?: number) => {
  const value = amount ?? 0;
  const sign = value < 0 ? "-" : EMPTY_STRING;

  return `${sign}$${getDecimalNumber(Math.abs(value))}`;
};

export const balanceTone = (balance?: number): string | undefined => {
  if (!balance) return undefined;
  if (balance > 0) return "#15803d";
  if (balance < 0) return "#b91c1c";

  return undefined;
};
